import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders, HttpParams} from '@angular/common/http';

import {BehaviorSubject, Observable, Subject} from 'rxjs';
import {tap} from "rxjs/operators";
import {DefaultService} from "../../shared/_services/abstract/default.service";

@Injectable()
export class PaymentWalletIntentService extends DefaultService {

    link: any;
    filters: any = {};
    onItemUpdate: BehaviorSubject<any>;
    onItemAdded: Subject<any>;
    onSearchTextChanged: Subject<any>;
    constructor(public override http: HttpClient,
    ) {
        super(http);
        this.setResourceLink('secured/payment/walletintent');
        this.onItemUpdate = new BehaviorSubject([]);
        this.onSearchTextChanged = new Subject();
        this.onItemAdded = new Subject();

    }



    public validatePayment(queryParams: any): Observable<any> {
        return this.http.post(this.endpoint + 'secured/payment/validatewalletpayment', queryParams)
            .pipe(
                tap((tokens: any) => {


                    },
                    err => {

                        console.log('error',err.error.errors)

                    }
                ))


    }


}
